import { render, staticRenderFns } from "./PdfTemplatesPage.vue?vue&type=template&id=6be4d712&"
import script from "./PdfTemplatesPage.vue?vue&type=script&lang=js&"
export * from "./PdfTemplatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports